<template>
  <div class="ac-wrap" id="registry">
    <!-- 注册界面 -->
    <div class="ac-con" v-if="status==0">
      <div class="ac-con-lt">
        <div class="ac-general">手机号</div>
        <div class="ac-general">验证码</div>
      </div>
      <div class="ac-con-ct">
        <div class="ac-general">
          <input type="text" name="" @keyup.down="changeFocus(1)" @keyup.up="changeFocus(1)" @keyup.enter="accountRegistry" v-model="phoneNum"
            placeholder="请输入手机号">
        </div>
        <div class="ac-general">
          <input type="text" style="width: 160px;float:left" name="" @keyup.down="changeFocus(0)" @keyup.enter="accountRegistry" @keyup.up="changeFocus(0)"
            v-model="imgcode" placeholder="请输入验证码">
          <span class="ac-verify" @click="changeVerify">
            <img :src="verifyUrl" alt="">
          </span>
        </div>

        <div class="ac-general">
          <div class="ac-btn" @click="accountRegistry">下一步</div>
        </div>
      </div>
      <div class="ac-con-rt">
        <div class="ac-general">
          <p class="ac-con-msg" v-if="phoneState.type!=''">
            <ep-alert :type="phoneState.type">{{phoneState.msg}}</ep-alert>
          </p>
        </div>
        <div class="ac-general">
          <p class="ac-con-msg" v-if="imgState.type!=''">
            <ep-alert :type="imgState.type">{{imgState.msg}}</ep-alert>
          </p>
        </div>
      </div>
    </div>
    <!-- 短信验证 -->
    <div class="ac-con" v-if="status==1">
      <div class="ac-con-lt">
        <div class="ac-general">手机号</div>
        <div class="ac-general">短信验证码</div>
      </div>
      <div class="ac-con-ct">
        <div class="ac-general">
          <span>{{formatPhone(phoneNum)}}</span>
        </div>
        <div class="ac-general">
          <input type="text" style="width: 160px;float:left" autofocus name="" @keyup.enter="smsVerify" v-model="smscode" placeholder="请输入验证码">
          <span :class="['ac-verify', 'ac-send',{'active':smsStatu}]" @click="isSendSms">{{smsCon}}</span>
        </div>

        <div class="ac-general">
          <div class="ac-btn" @click="smsVerify">下一步</div>
        </div>
      </div>
      <div class="ac-con-rt">
        <div class="ac-general"></div>
        <div class="ac-general">
          <p class="ac-con-msg" v-if="smsState.type!=''">
            <ep-alert :type="smsState.type">{{smsState.msg}}</ep-alert>
          </p>
        </div>
      </div>
    </div>

    <!-- 设置密码 -->
    <div class="ac-con" v-if="status==2">
      <div class="ac-con-lt">
        <div class="ac-general">设置密码</div>
        <div class="ac-general">确认密码</div>
        <div class="ac-general">真实姓名</div>
      </div>
      <div class="ac-con-ct">
        <div class="ac-general">
          <input type="password" autofocus name="" v-model="pwd" @keyup.enter="setPassword" @focus="pwdStatu={type: '',msg: ''};confirmStatu={type: '',msg: ''};pwdState=true"
            @blur="pwdState=false" placeholder="请输入密码">
        </div>
        <div class="ac-general">
          <input type="password" name="" v-model="confirm" @keyup.enter="setPassword" placeholder="请再次输入密码">
        </div>
        <div class="ac-general">
          <input type="text" name="" v-model="rgname" @keyup.enter="setPassword" placeholder="输入您的姓名，申报时对审批者可见">
        </div>
        <div class="ac-general">
          <div class="ac-btn" @click="setPassword">完成</div>
        </div>
      </div>
      <div class="ac-con-rt">
        <div class="ac-general">
          <p class="message-tip" v-if="pwdShowTip">
            密码长度为8-20个字符，且至少包含1个大写字母，1个小写字母和1个数字
          </p>
          <p class="ac-con-msg" v-if="pwdStatu.type!=''">
            <ep-alert :type="pwdStatu.type">{{pwdStatu.msg}}</ep-alert>
          </p>
        </div>
        <div class="ac-general">
          <p class="ac-con-msg" v-if="confirmStatu.type!=''">
            <ep-alert :type="confirmStatu.type">{{confirmStatu.msg}}</ep-alert>
          </p>
        </div>
        <div class="ac-general">
          <p class="ac-con-msg" v-if="rgnameState.type!=''">
            <ep-alert :type="rgnameState.type">{{rgnameState.msg}}</ep-alert>
          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import account from '../../data/ucenter/account.js'
  import captcha from '../../data/ucenter/captcha.js'

  export default {
    data() {
      return {
        // 手机号码
        phoneNum: '',
        // 手机号码状态
        phoneState: {
          type: '',
          msg: ''
        },
        // 图片验证码
        imgcode: '',
        // 图片验证码状态
        imgState: {
          type: '',
          msg: ''
        },
        // 操作状态
        status: 0,
        // 焦点状态
        focusStatu: 0,
        // 验证吗地址
        verifyUrl: '/api/ucenter/captcha/get?width=120&height=40',
        // 短信按钮状态
        smsStatu: {
          type: '',
          msg: ''
        },
        // 短信校验状态
        smsState: {
          type: '',
          msg: ''
        },
        // 短信验证码
        smscode: '',
        // 短信验证码按钮
        smsCon: '发送信息',
        // 短信验证码默认时间
        smsTime: 60,
        // 输入密码
        pwd: '',
        // 密码状态
        pwdStatu: {
          type: '',
          msg: ''
        },
        // 密码校验
        pwdUrl: ['../../../static/img/1.png', '../../../static/img/1.png', '../../../static/img/1.png',
          '../../../static/img/1.png'
        ],
        pwdShowTip:false,
        // 校验框状态
        pwdState: false,
        // 再次输入密码
        confirm: '',
        // 再次输入状态
        confirmStatu: {
          type: '',
          msg: ''
        },
        // 姓名
        rgname: '',
        // 姓名状态
        rgnameState: {
          type: '',
          msg: ''
        }
      }
    },
    mounted() {
      this.changeFocus(0)
      this.changeVerify()
    },
    watch: {
      // 实时监听密码变动
      pwd() {
        this.formatPwd(this.pwd)
      }
    },
    methods: {
      // 账号注册
      accountRegistry() {
        // 校验用户名格式
        let userState = account.vertify_username(this.phoneNum)
        let changePhoneState = (type, msg) => {
          this.phoneState.type = type;
          this.phoneState.msg = msg
        }
        if (userState.type != 2) {
          changePhoneState('error', userState.msg)
          this.smsStatu = true
          return
        }
        // 校验用户是否存在
        (async() => {
          let userExit = await account.exit_username(this.phoneNum)
          if (userExit) {
            changePhoneState('error', '手机号已注册')
            this.smsStatu = true
            this.changeVerify()
            return
          } else {
            changePhoneState('success', '手机号格式正确')
            this.smsStatu = false
            _verity_imgcode()
          }
        })()

        let _verity_imgcode = () => {
          // 校验图片验证码格式
          let imgState = captcha.verity_code(this.imgcode)
          let changeImgState = (type, msg) => {
            this.imgState.type = type
            this.imgState.msg = msg
          }
          if (imgState.type != 2) {
            changeImgState('error', imgState.msg)
            return
          }
          // 验证图片验证码是否正确
          (async() => {
            let imgCorrect = await captcha.correct_imgcode(this.imgcode)
            if (imgCorrect) {
              this.status = 1
              this.$emit('change', 1)
            } else {
              changeImgState('error', '验证码错误')
              this.changeVerify()
              return
            }
          })()
        }

      },
      // 短信验证
      smsVerify() {
        // 校验短信验证码格式
        let smsState = captcha.verity_six_code(this.smscode)
        let changeSmsState = (type, msg) => {
          this.smsState.type = type
          this.smsState.msg = msg
        }
        if (smsState.type != 2) {
          changeSmsState('error', smsState.msg)
          return
        }
        // 验证短信验证码是否正确
        (async() => {
          let smsCorrect = await captcha.correct_smscode(this.smscode)
          if (smsCorrect) {
            this.status = 2
            this.$emit('change', 2)
          } else {
              this.smscode = '';
            changeSmsState('error', '验证码错误')
            this.changeVerify()
            return
          }
        })()
      },
      // 设置密码
      setPassword() {
        this.pwdState = false
        // 验证密码格式是否正确
        let pwdState = account.vertify_password(this.pwd)
        let changePwdState = (type, msg) => {
          this.pwdStatu.type = type
          this.pwdStatu.msg = msg
        }
        if (pwdState.type != 2) {
          changePwdState('error', pwdState.msg)
          return
        } else {
          changePwdState('success', pwdState.msg)
        }
        // 验证密码是否输入一致
        let pwdAccord = account.vertify_accord(this.pwd, this.confirm)
        let changeConfirmStatu = (type, msg) => {
          this.confirmStatu.type = type
          this.confirmStatu.msg = msg
        }
        if (pwdAccord.type != 2) {
          changeConfirmStatu('error', pwdAccord.msg)
          return
        } else {
          changeConfirmStatu('success', pwdAccord.msg)
        }
        // 验证用户名是否为空并发起注册
        let nameState = account.vertify_name(this.rgname)
        let changeNameState = (type, msg) => {
          this.rgnameState.type = type
          this.rgnameState.msg = msg
        }
        if (nameState.type != 2) {
          changeNameState('error', nameState.msg)
          return
        } else {
          changeNameState('success', nameState.msg)
        }
        // 注册用户
        (async() => {
          let registryState = account.registry({
            username: this.phoneNum,
            password: this.pwd,
            name: this.rgname,
            utype: 1,
            client: true
          })
          if (registryState) {
            this.$message.success('用户注册成功');
            setTimeout(() => {
              // 登录
              (async() => {
                let isLogin = await account.login({
                  username: this.phoneNum,
                  password: this.pwd,
                  client: true
                })
                if (isLogin.isok) {
                  this.$router.push('/home')
                  this.$message.success('用户登录成功');
                } else {
                  this.$router.push('/login')
                }
              })()
            }, 2000)
          } else {
            this.$message.error('用户注册失败，请重试');
          }
        })()
      },
      // 切换焦点
      changeFocus(num) {
        let allInput = document.getElementById('registry').getElementsByClassName('ac-con')[0].querySelectorAll('input')
        if (num < allInput.length && num > -1) {
          allInput[num].focus()
        }
      },
      // 格式化手机号码
      formatPhone(val) {
        return account.fromat_username(val)
      },
      // 切换验证码
      changeVerify() {
        this.verifyUrl = captcha.verityimg_change()
      },
      // 是否开启短信验证
      isSendSms() {
        if (!this.smsStatu) {
          (async() => {
            let smsCodeState = await captcha.get_smscode({
              imgcode: this.imgcode,
              username: this.phoneNum
            })
            let changeSmsState = (type, msg) => {
              this.smsState.type = type
              this.smsState.msg = msg
            }
            if (smsCodeState) {
              changeSmsState('success', '发送成功')
            } else {
              changeSmsState('error', '发送失败')
            }
          })()
          this.sendSms()
        } else {
          return
        }
      },
      // 短信验证码
      sendSms() {
        if (this.smsTime < 0) {
          this.smsCon = '重新发送'
          this.smsStatu = false
          this.smsTime = 60
        } else {
          this.smsCon = `重新发送(${this.smsTime})`
          this.smsStatu = true
          setTimeout(() => {
            this.smsTime--
              this.sendSms()
          }, 1000)
        }
      },
      // 实时校验密码格式
      formatPwd(data) {
        let pwdState = account.vertify_password(data);
        this.pwdShowTip = pwdState.type!=2;
      }
    }
  }

</script>

<style lang="stylus" scoped>
  .ac-wrap {
    width: 100%;
    height: 100%;
    position: relative;
    .ac-con {
      width: 100%;
      height: 100%;
      position: relative;
      display: inline-flex;
      .ac-con-lt {
        width: 100px;
        height: 100%;
        margin-right: 30px;
        font-size: 16px;
        color: #666666;
        text-align: right;
      }
      .ac-con-ct {
        width: 340px;
        height: 100%;
        margin-right: 30px;
        text-align: left;
        .ac-btn {
          width: 100%;
          height: 100%;
          text-align: center;
          border-radius: 5px;
          background: #2db7f5;
          transition: all .3s ease-in-out;
          color: #fff;
          cursor: pointer;
          a {
            text-decoration: none;
            color: #fff;
          }
          &:hover {
            background: #57c5f7;
          }
        }
        .ac-verify {
          display: inline-block;
          height: 40px;
          width: 120px;
          border: 1px solid #DCDCDC;
          float: right;
          border-radius: 5px;
          overflow: hidden;
        }
        .ac-send {
          text-align: center;
          color: #666;
          font-size: 14px;
          border-radius: 5px;
          cursor: pointer;
          &:hover {
            border: 1px solid #2ea9df;
            color: #2ea9df;
          }
        }
        .active {
          cursor: no-drop;
        }
      }
      .ac-con-rt {
        flex: 1;
        height: 100%;
        .ac-con-msg {
          display: block;
          height: 40px;
          width: 100%;
          line-height: 50px;
          text-align: left;
        }
        .message-tip{
          font-size: 14px;
          color: red;
          line-height: 18px;
        }
        .ac-check {
          height: 145px;
          width: 164px;
          background: url('../../../static/img/kuang.png') no-repeat center;
          box-sizing: border-box;
          padding: 10px;
          .ac-check-list {
            height: 30px;
            color: #666;
            font-size: 12px;
            text-align: left;
            text-indent: 10px;
            img {
              margin-right: 10px;
              /* vertical-align: middle; */
            }
          }
        }
      }
      .ac-general {
        width: 100%;
        height: 40px;
        margin-bottom: 30px;
        line-height: 40px;
      }
      input {
        width: 100%;
        height: 100%;
        border: 1px solid #c1c1c1;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 0 10px;
        &:focus {
          outline: none;
          box-shadow: 0 0 5px rgba(85, 190, 234, 1);
          border: 1px solid #55beec;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// Registry.vue?62e4a9bb